import p from './remove';

export * from './remove';
export default p;
